import { GalleryQuickVote, VoteOption } from "./JudgingInterfaces";
export const IN_OUT_ROUND_NAME = "In/Out";
export const ONE_TO_TEN_ROUND_NAME = "1-10";
export const MULTIVARIABLE_ROUND_NAME = "Multivariable Judging";
export const STATUE_ROUND_NAME = "Statue";
export const GRAND_ROUND_NAME = "Grand";
export const WINNER_ROUND_NAME = "Winner";

export const getRoundBehavior = (
	roundType?: string | null,
	roundBehaviorType?: string | null,
) => roundBehaviorType || roundType || "";

export const isMultivariableRound = (
	roundType?: string | null,
	roundBehaviorType?: string | null,
) =>
	getRoundBehavior(roundType, roundBehaviorType) === MULTIVARIABLE_ROUND_NAME;

export const isScoreRound = (
	roundType?: string | null,
	roundBehaviorType?: string | null,
) => {
	const roundBehavior = getRoundBehavior(roundType, roundBehaviorType);
	return (
		roundBehavior === ONE_TO_TEN_ROUND_NAME ||
		roundBehavior === MULTIVARIABLE_ROUND_NAME
	);
};

export const isGrandOrWinnerRound = (
	roundType?: string | null,
	roundBehaviorType?: string | null,
) => {
	const roundBehavior = getRoundBehavior(roundType, roundBehaviorType);
	return (
		roundBehavior === GRAND_ROUND_NAME || roundBehavior === WINNER_ROUND_NAME
	);
};

export const isInOutRound = (
	roundType?: string | null,
	roundBehaviorType?: string | null,
) => getRoundBehavior(roundType, roundBehaviorType) === IN_OUT_ROUND_NAME;

export const isStatueRound = (
	roundType?: string | null,
	roundBehaviorType?: string | null,
) => getRoundBehavior(roundType, roundBehaviorType) === STATUE_ROUND_NAME;

export const usesEntryResultDisplayMode = (
	roundType?: string | null,
	roundBehaviorType?: string | null,
	voteOptions?: VoteOption[] | null,
) =>
	isInOutRound(roundType, roundBehaviorType) &&
	Boolean(
		voteOptions?.some((option) => {
			const awardAlias = option.awardAlias?.trim();
			return (
				option.isAward &&
				Boolean(awardAlias) &&
				awardAlias !== option.name.trim()
			);
		}),
	);

export const hasSubmittedVote = (vote?: GalleryQuickVote | null) =>
	Boolean(
		vote &&
		(vote.hasSubmittedVote ??
			((vote.voteOptionId !== null && vote.voteOptionId !== undefined) ||
				(vote.compositeScore !== null && vote.compositeScore !== undefined))),
	);

export const isAbstainedVote = (vote?: GalleryQuickVote | null) =>
	Boolean(vote && (vote.isAbstained || vote.voteOption?.name === "Abstain"));

export const isPartiallyScoredVote = (vote?: GalleryQuickVote | null) =>
	Boolean(
		vote &&
		!hasSubmittedVote(vote) &&
		vote.criterionScores &&
		vote.criterionScores.some((score) => score.score > 0),
	);

export const formatJudgingScore = (score?: number | null) => {
	if (score === null || score === undefined) {
		return null;
	}

	return score.toFixed(2).replace(/\.?0+$/, "");
};

export const getVoteDisplayLabel = (
	vote?: GalleryQuickVote | null,
	roundType?: string | null,
	roundBehaviorType?: string | null,
) => {
	if (!vote) {
		return null;
	}

	if (isMultivariableRound(roundType, roundBehaviorType)) {
		if (isAbstainedVote(vote)) {
			return "Abstain";
		}

		return formatJudgingScore(vote.compositeScore);
	}

	if (!vote.voteOption) {
		return null;
	}

	if (isGrandOrWinnerRound(roundType, roundBehaviorType)) {
		return vote.voteOption.name === "Grand" || vote.voteOption.name === "Winner"
			? vote.voteOption.name
			: "X";
	}

	return vote.voteOption.name;
};

export const getVoteColorName = (vote?: GalleryQuickVote | null) => {
	if (!vote) {
		return "Unvoted";
	}

	if (vote.compositeScore !== null && vote.compositeScore !== undefined) {
		return String(Math.min(10, Math.max(1, Math.round(vote.compositeScore))));
	}

	return vote.voteOption?.name || "Unvoted";
};
